import { useQuery } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";
import axios from "../../../../utils/axiosInceptor";

type MaintenancePriorities = Record<string, string>;

const getMaintenancePriorities = async (): Promise<MaintenancePriorities> => {
  const url = `${apiV1Endpoint}/maintenance/priorities`;
  const response = await axios.get<ApiResponse<MaintenancePriorities>>(url);
  return response.data.result;
};

export const useGetMaintenancePriorities = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["maintenance-priorities"],
    queryFn: getMaintenancePriorities,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  return {
    priorities: data,
    isLoadingPriorities: isLoading,
    isErrorPriorities: isError,
    errorPriorities: error,
  };
};
